module.exports = __webpack_public_path__ + "img/img_festa2.15d59529.jpg";